import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateReleaseContacts } from '@/apis/lists';
import { useSaladBar } from '@australiangreens/ag-internal-components';
import type { ToggleValue } from './types';

type MutVars = {
  chosenUserSub: string;
  toggleValue: ToggleValue;
  releaseContactsState: string;
};

export const useReleaseContacts = (listId: number) => {
  const { getAccessTokenSilently, user } = useAuth0();
  const queryClient = useQueryClient();
  const { enqueueSuccessNotification } = useSaladBar();

  return useMutation({
    mutationFn: async ({ chosenUserSub, toggleValue, releaseContactsState }: MutVars) => {
      const releasedForSub = chosenUserSub
        ? chosenUserSub
        : toggleValue == 'me'
          ? user?.sub || ''
          : null;

      const token = await getAccessTokenSilently();

      await updateReleaseContacts(token, listId, {
        releaseContactsState,
        releasedForSub,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list', listId] });
      enqueueSuccessNotification('Contact(s) have been released');
    },
  });
};
